module.exports = __webpack_public_path__ + "static/media/dummyImage.4278e006.svg";